import { Middleware } from 'redux'
import { ActionTypes } from './types'

const authMiddleware: Middleware =
	({ dispatch }) =>
	next =>
	action => {
		if (!action.error) {
			return next(action)
		}
		switch (action.error.response.status) {
			case 401:
			case 419:
			case 503:
				dispatch({ type: ActionTypes.LOGOUT })
				window.location.reload()
				break
			default:
				return next(action)
		}
	}

export default authMiddleware
